module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.ready && !_vm.modal) ? _c('div', {
    staticClass: "app-loading"
  }, [(_vm.networkError) ? _c('div', [_c('p', [_c('strong', [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("\n            Unable to reach Meteo-Parapente servers. Please check your connection.\n          ")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('translate', {
    attrs: {
      "translate-context": "startup"
    }
  }, [_vm._v("\n          If the problem persists, contact support@meteo-parapente.com\n        ")])], 1)]) : _c('img', {
    attrs: {
      "src": "img/load.gif",
      "alt": "loading..."
    }
  }), _vm._v(" "), _c('update-progress')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', [_c('connexion-check'), _vm._v(" "), _c('drag-surface'), _vm._v(" "), (_vm.ready) ? _c('main-view') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('modal-dialog')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    staticClass: "btn-error",
    attrs: {
      "type": "button",
      "value": "Retry",
      "onclick": "document.location.reload(true)"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7971c713"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/app/template.vue
// module id = 344
// module chunks = 1